import MqttGateway from './lib/mqtt_gateway';

export default class AgentGateway extends MqttGateway {
  get version() {
    return '1';
  }

  get topicPattern() {
    return 'agents/+';
  }

  request() {
    return super._subscribeAndFetch();
  }

  onReceive(entityDto) {
    this.notifyObservers('handleEntity', entityDto);
  }

  onDelete(topic, parsedTopicParams) {
    this.notifyObservers('handleDelete', parsedTopicParams[0]);
  }

  onFetchResponse(fetchResultDto) {
    this.notifyObservers('handleRequestedEntities', fetchResultDto);
  }

  onFetchError(errorDto) {
    this.notifyObservers('handleRequestError', errorDto);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/agent_gateway.js